import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createCrmTheme } from "@/theme/crmTheme";
import { ThemeCssVarsSync } from "@/components/common/ThemeCssVarsSync";

const ThemeContext = createContext({ mode: "light", toggleTheme: () => {} });

const STORAGE_KEY = "erp_theme_mode";

function AppThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* ignore */
    }
    document.documentElement.style.colorScheme = mode;
    const loader = document.getElementById("app-initial-loader");
    if (loader) {
      loader.style.background =
        mode === "dark" ? "#090d16" : "#f8fafc";
    }
  }, [mode]);

  const toggleTheme = () => {
    setMode((prev) => (prev === "light" ? "dark" : "light"));
  };

  const theme = useMemo(() => createCrmTheme(mode), [mode]);
  const contextValue = useMemo(() => ({ mode, toggleTheme }), [mode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ThemeCssVarsSync />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

function useAppTheme() {
  return useContext(ThemeContext);
}

export { AppThemeProvider, useAppTheme };
